/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export const EDIT_ALL_SCENARIO_LAYERS_RESPONSE = {
	message: "Updated with success"
};

export const EDIT_SCENARIO_LAYER_RESPONSE = {
	message: "Updated with success"
};
